
export default {

  table: {
    background: '#fff',
    padding: 10
  },
  toolbar: {
    margin: '0 0 20px 0'
  }
}




// WEBPACK FOOTER //
// ./src/lawdocument/lawdocument.css.js